import React from 'react';
import {Card, Divider, Table } from 'antd';
import PnL from '../../../components/PnL';
import NivoBarChart from '../../../charts/nivo/NivoBarChart';
import {prepareCalendarReturns} from "../utils";
import {RankColumn, NameColumn} from "../tableUtils";

const PerformanceHistory = ({ items, itemColors }) => {
  const {data, keys, customColors} = prepareCalendarReturns([...items], itemColors);
  console.log(itemColors);
  console.log(items);


  const columns = [
      RankColumn,
      NameColumn(itemColors),
    {
      title: 'YTD',
      dataIndex: 'ytd',
      key: 'ytd',
      // Use renderPnL for formatting YTD
      render: (v, r) => PnL({value: r?.total?.ytd}),
      sorter: (a, b) => a?.total?.ytd - b?.total?.ytd,
    },
    {
      title: '1 Year % Return',
      dataIndex: 'oneYear',
      key: 'oneYear',
      // Use renderPnL for formatting 1 Year % Return
      render: (v, r) => PnL({value: r?.['252']?.pct_r}),
      sorter: (a, b) => a?.['252']?.pct_r - b?.['252']?.pct_r,
    },
    {
      title: '3 Year % Return',
      dataIndex: 'threeYear',
      key: 'threeYear',
      // Use renderPnL for formatting 3 Year % Return
      render: (v, r) => PnL({value: r?.['756']?.pct_r}),
      sorter: (a, b) => a?.['756']?.pct_r - b?.['756']?.pct_r,
    },
    {
      title: '5 Year % Return',
      dataIndex: 'fiveYear',
      key: 'fiveYear',
      // Use renderPnL for formatting 5 Year % Return
      render: (v, r) => PnL({value: r?.['1260']?.pct_r}),
      sorter: (a, b) => a?.['1260']?.pct_r - b?.['1260']?.pct_r,
    },
  ];

  // const dataSource = tableData.map((row, index) => ({
  //   key: index,
  //   symbol: row[0],
  //   ytd: row[1],
  //   oneYear: row[2],
  //   threeYear: row[3],
  //   fiveYear: row[4],
  // }));

  return (
        <>
          <Table columns={columns} dataSource={items} pagination={{pageSize: 10}} bordered={true} className={'striped'}/>
          <Divider/>
          <div style={{height: 400}} className={'dropped-shadow'}>
            <NivoBarChart data={data}
                          keys={keys}
                          customColors={customColors}
                          legendSize={'small'}
                          barPadding={0.4}
                          borderRadius={4}
                          useBarShadow={false}
            />
          </div>
        </>
  )
};

export default PerformanceHistory;
